import { Component, OnInit, inject } from '@angular/core';
import { AppLoaderService } from 'src/app/services/app-loader.service';

@Component({
  selector: 'app-loader',
  template: `
    <div class="spinner-container" *ngIf="loader === true">
      <p-progress-spinner></p-progress-spinner>
    </div>
  `,
  styles: [],
  standalone: false  //NOSONAR
})
export class AppLoaderComponent implements OnInit {
  loaderService = inject(AppLoaderService);

  loader = false;

  ngOnInit() {
    this.loaderService.loadingChanges.subscribe((res) => {
      this.loader = res;
    });
  }
}
